<template>
    <v-select
        v-model    = "selected"
        :items     = "items"
        :readonly  = "readonly"
        :disabled  = "readonly"
        item-value = "id"
        item-text  = "name"
        :label     = "label"
        @change    = "onChange"
        return-object
    />
</template>

<script>
export default {
    name : "InbMessageTypes",
    props: {
        value: {
            required: true
        },
        label: {
            required: true
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        selected: null
    }),

    mounted() {
        this.selected = this.value;
    },

    computed: {
        items () {
            return this.$store.getters.messageTypes;
        }
    },

    watch: {
        value () {
            this.selected = this.value;
        }
    },

    methods: {
        onChange () {
            this.$emit('input', this.selected);
            this.$emit('changed', this.selected);
        }
    }
}
</script>

<style scoped>

</style>